/** Ação para atualizar a lista de permissões no redux */
export default function updatePermissions() {
  return {
    type: "PERMISSION_UPDATE"
  };
}



// WEBPACK FOOTER //
// ./src/store/actions/permissions/update.js